import { useMutation, useQuery } from "react-query";
import isEmpty from "lodash/isEmpty";
import omit from "lodash/omit";
import reject from "lodash/reject";

import { gwtClient } from "@monta/utils";

import type { QueryKey } from "react-query";
import type { SetQuestionLike } from "./like-question.types";

export const setQuestionLike = {
  url: () => `/exam/likeQuestion`,
  fn: async (request: SetQuestionLike["request"]) => {
    const { data } = await gwtClient<SetQuestionLike["response"]>({
      ...request?.axiosConfig,
      method: "POST",
      url: setQuestionLike.url(),
      data: request.body
    });
    return data;
  },
  key: (request: SetQuestionLike["request"]) => {
    return reject(
      [setQuestionLike.url(), omit(request ?? {}, "axiosConfig")],
      isEmpty
    ) as QueryKey;
  },
  query: (options: SetQuestionLike["queryOptions"]) => ({
    ...options.queryOptions,
    keepPreviousData: true,
    queryKey: setQuestionLike.key(options.request),
    queryFn: () => setQuestionLike.fn(options.request)
  }),
  useQuery: (options: SetQuestionLike["queryOptions"]) =>
    useQuery(setQuestionLike.query(options)),
  useMutation: (options?: SetQuestionLike["mutationOptions"]) =>
    useMutation({
      ...options,
      mutationFn: setQuestionLike.fn
    })
};
